/**
 * 侧边栏菜单字符串 icon → lucide 组件（勿使用 import * from 'lucide-react'，会与 Farm+HMR+pnpm 深层路径冲突）。
 */
import type { LucideIcon } from "lucide-react";
import {
  Activity,
  BarChart3,
  Bell,
  Bot,
  Brain,
  Clock,
  ClipboardList,
  Database,
  FileText,
  FolderOpen,
  GitBranch,
  Globe,
  Home,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  Package,
  Puzzle,
  Server,
  Settings,
  Shield,
  Sparkles,
  Store,
  Terminal,
  Users,
  Workflow,
  Wrench,
  Circle,
  FlaskConical,
  MessagesSquare,
} from "lucide-react";

/** 内置 registerBuiltinShell 与各插件常用名；未知名称回退 Circle */
const SIDEBAR_LUCIDE_BY_NAME: Record<string, LucideIcon> = {
  Home,
  FlaskConical,
  MessagesSquare,
  Bot,
  FileText,
  Clock,
  ClipboardList,
  Package,
  Store,
  Settings,
  KeyRound,
  FolderOpen,
  Database,
  LayoutDashboard,
  LayoutGrid,
  Puzzle,
  Users,
  Terminal,
  Server,
  Activity,
  BarChart3,
  Bell,
  Brain,
  GitBranch,
  Globe,
  Shield,
  Sparkles,
  Wrench,
  Workflow,
};

export function getSidebarLucideIcon(name: string): LucideIcon {
  return SIDEBAR_LUCIDE_BY_NAME[name] ?? Circle;
}
